import React, { useRef, useState } from 'react';
import UserAvatar from './UserAvatar';
import { uploadProfileImageFile } from '../utils/profileUpload';
import './ProfilePhotoEditor.css';

const ProfilePhotoEditor = ({ user, onUserUpdate, size = 'lg', showHint = true }) => {
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handlePickImage = () => {
    if (uploading) return;
    fileInputRef.current?.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;

    setError('');
    setUploading(true);

    try {
      const updatedUser = await uploadProfileImageFile(file);
      onUserUpdate?.(updatedUser);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          'Could not upload image. Use JPG or PNG under 2MB.'
      );
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="profile-photo-editor">
      <input
        ref={fileInputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/gif"
        className="profile-photo-editor-input"
        onChange={handleFileChange}
        aria-hidden="true"
        tabIndex={-1}
      />
      <div className={`profile-photo-editor-wrap profile-photo-editor-${size}`}>
        <div className="profile-photo-editor-avatar">
          <UserAvatar user={user} size={size} />
        </div>
        <button
          type="button"
          className="profile-photo-editor-btn"
          onClick={handlePickImage}
          disabled={uploading}
          aria-label="Change profile picture"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
          </svg>
        </button>
      </div>
      {showHint && (
        <button
          type="button"
          className="profile-photo-editor-link"
          onClick={handlePickImage}
          disabled={uploading}
        >
          {uploading ? 'Uploading...' : 'Change profile photo'}
        </button>
      )}
      {error && (
        <p className="profile-photo-editor-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default ProfilePhotoEditor;
